import { isNil } from './helpers'

export enum HttpStatus {
  OK = 200,
  Accepted = 202,
  LongRunning = 204,
  NoContent = 204,
  TemporaryRedirect = 307,
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  EditorConflict = 409,
  Error = 500
}

export const isServerError = (status?: HttpStatus): boolean => {
  return isNil(status) || status >= 500
}
